// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"6fcfce2a","803":"a7299ce1","888":"0773fbb9"}[chunkId] + ".chunk.js";
};